import { render, staticRenderFns } from "./EditableText.vue?vue&type=template&id=6baa89da&"
import script from "./EditableText.vue?vue&type=script&lang=js&"
export * from "./EditableText.vue?vue&type=script&lang=js&"
import style0 from "./EditableText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports